var Web3 = require('./lib/web3');

// dont override global variable
if (typeof window !== 'undefined' && typeof window.Web3 === 'undefined') {
    window.Web3 = Web3;
}

module.exports = Web3;



//////////////////
// WEBPACK FOOTER
// ./~/truffle-blockchain-utils/~/web3/index.js
// module id = 851
// module chunks = 0